import React, { useEffect } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import LoginPageWrapper from '../Components/LoginPageWrapper';
import LoginFormHeader from '../Components/LoginFormHeader';

import './Organization.custom.scss';
import './Organization.theme.scss';

const spinnerId = 'organizationForm';

function Organization(props) {
  const { isLoading, response, login, goToLoginPage } = props;

  useEffect(() => {
    if (!response) {
      goToLoginPage();
    }
    // eslint-disable-next-line
  }, []);

  const availablePaths = get(response, 'data.availablePaths', []);

  return (
    <LoginPageWrapper className="react-page-organization-page">
      {isLoading && <SimpleSpinner id={spinnerId} />}
      <LoginFormHeader
        actionMessage="Welcome to Reaxys Choice Screen"
        infoMessage="To log in please select one of the departments below."
      />
      <div className="organization-page-form-wrapper">
        <ul className="els-list els-medium els-link-list">
          {availablePaths.map((data) => {
            return (
              <li key={data.label}>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  className="e2e-select-organization"
                  tabIndex="0"
                  // eslint-disable-next-line react/jsx-no-script-url,no-script-url
                  href="null"
                  onClick={(e) => {
                    e.preventDefault();
                    login(data.id);
                  }}>
                  {data.label}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </LoginPageWrapper>
  );
}

Organization.propTypes = {
  isLoading: PropTypes.bool,
  response: PropTypes.object,
  login: PropTypes.func.isRequired,
  goToLoginPage: PropTypes.func.isRequired,
};

export default Organization;
